import React, {useEffect, useState} from 'react';
import {useNavigate, useParams} from 'react-router-dom';
import {adminGetAffiliateAccounts, adminGetAffiliateClicks} from "../../../services/api/admin";
import PaginatedTable from "../../../components/Block/Table/PaginatedTable";
import LoadSpinner from "../../../components/Common/LoadSpinner";
import Pagination from "../../../components/Block/Pagination/Pagination";
import RangeDatePicker from "../../../components/Dashboard/Charts/RangeDatePicker";
import {Button, Checkbox, Dropdown, Label} from "flowbite-react";
import {AngleDown} from "flowbite-react-icons/outline";
import moment from "moment";

const AffiliateClicks = () => {
    const {page, per_page} = useParams();
    const [affiliatesFetched, setAffiliatesFetched] = useState(false);
    const [selectedAffiliateIds, setAffiliateIds] = useState([]);
    const [chartRange, setChartRange] = React.useState(null);
    const [tableHeaders, setTableHeaders] = React.useState([]);
    const [affiliateData, setAffiliateData] = useState([]);
    const [affiliateAccounts, setAffiliateAccounts] = useState(null);

    const [affiliatePagination, setAffiliatePagination] = useState({
        total: 0,
        count: 0,
        per_page: parseInt(per_page, 10) || 10,
        current_page: parseInt(page, 10) || 1,
        total_pages: 1
    });
    const navigate = useNavigate();

    const [activeFilterOptions, setActiveFilterOptions] = useState({
        page: affiliatePagination.current_page,
        per_page: affiliatePagination.per_page,
        from: null,
        to: null,
        affiliate_id: null,
    });


    const fetchAffiliateAccounts = async () => {
        try {
            const {data} = await adminGetAffiliateAccounts();
            setAffiliateAccounts(data);
        } catch (e) {
            console.error('Error fetching affiliate accounts:', e);
        }
    }

    useEffect(() => {
        if (!affiliateAccounts)
            fetchAffiliateAccounts().then(() => console.log('Affiliate accounts fetched'));
    }, [affiliateAccounts]);


    const getTableHeaders = (data) => {
        const temp = [];

        if (data && data.length > 0)
            Object.keys(data?.[0]).map?.((item) => {
                const headTitle = item.split('_').join(' ').toUpperCase();
                temp.push({data: headTitle, classes: ""});
                return false;
            })
        setTableHeaders(temp);
    }


    const fetchAffiliateClicks = async () => {
        if (!activeFilterOptions?.page || !parseInt(activeFilterOptions?.per_page) > 0) return;
        if (!affiliateData.length && !affiliatesFetched)
            try {

                const {data, meta} = await adminGetAffiliateClicks(activeFilterOptions);
                const transformedData = data.map((item) => {
                    const tempData = {};
                    Object.keys(item).map((key) => tempData[key] = {data: item[key], classes: "sl-min-w-10"})
                    return tempData;
                });

                getTableHeaders(data);
                setAffiliatesFetched(true);
                setAffiliateData(transformedData);
                setAffiliatePagination(meta.pagination);
                setActiveFilterOptions({
                    ...activeFilterOptions,
                    page: meta.pagination.current_page,
                    per_page: meta.pagination.per_page
                })

            } catch (e) {
                console.error('Error fetching conversations:', e);
            }
    }

    React.useEffect(() => {
            fetchAffiliateClicks(activeFilterOptions).then(r => console.log('Conversations fetched'));
        },
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [activeFilterOptions]);


    React.useEffect(() => {

            if (!page && !per_page) {
                onClickReset(true);
                return
            }

            setActiveFilterOptions({
                ...activeFilterOptions,
                page: page || 1,
                per_page: per_page || 10
            })
            setAffiliateData([]);
            setAffiliatesFetched(false);
        },
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [page, per_page]);


    const onClickFilter = () => {
        let isValid = true;

        if (chartRange?.from && chartRange?.to)
            isValid = moment(chartRange.to).isSameOrAfter(moment(chartRange.from));

        if (!isValid)
            return;

        setActiveFilterOptions({
            ...activeFilterOptions,
            ...(chartRange?.to ? {to: moment(chartRange.to).endOf('day').format('YYYY-MM-DD HH:mm:ss')} : {}),
            ...(chartRange?.from ? {from: chartRange.from} : {}),
            affiliate_id: selectedAffiliateIds,
            page: 1,
            per_page: 10
        });
        setAffiliateData([]);
        setAffiliatesFetched(false);
        navigate(`/admin/affiliate_clicks/1/${affiliatePagination.per_page}`);
    }

    const onClickReset = (skipNavigate = false) => {
        setActiveFilterOptions({
            page: 1,
            per_page: 10,
            from: null,
            to: null,
            affiliate_id: null
        })
        setChartRange({
            from: null,
            to: null,
        });
        setAffiliateIds([]);
        setAffiliateData([]);
        setAffiliatesFetched(false);
        if (!skipNavigate) navigate(`/admin/affiliate_clicks/1/${affiliatePagination.per_page}`);

    }


    const getDropdownLabel = () => {
        if (selectedAffiliateIds.length) {
            const label = affiliateAccounts?.filter(item => selectedAffiliateIds?.includes(item.affiliate_id)).map(item => item.name).join(', ');
            return label.length > 15 ? label.substring(0, 15) + '...' : label;
        }
        return 'Select Affiliate';
    }

    return (
        <div>
            <main className="sl-main sl-mt-8">
                <div className="sl-container sl-m-auto sl-my-8 sl-flex sl-flex-col sl-gap-3">
                    <h1 className={"sl-text-xl sl-text-gray-900"}>Affiliate Clicks</h1>
                    <div className={"sl-flex sl-flex-row sl-gap-2"}>
                        <RangeDatePicker setChartRange={setChartRange} skipMode={true} chartRange={chartRange}/>

                        <Dropdown
                            dismissOnClick={false}
                            label={""}
                            renderTrigger={() => <div
                                className={"sl-flex flex-row sl-gap-2 sl-border-radius-8 sl-bg-white sl-border-gray-300 sl-border-1 sl-border-solid sl-shadow-xs sl-pr-16 sl-pl-16 sl-pt-10 sl-pb-10 sl-cursor-pointer "}>
                                    <span className={"sl-text-gray-700 sl-font-medium sl-text-sm"}>{getDropdownLabel()}
                                    </span>
                                <AngleDown size={20} color={"#344054"}/>
                            </div>}
                        >
                            <div className={"sl-p-4 sl-flex sl-flex-col sl-gap-2"}>
                                {affiliateAccounts && affiliateAccounts.map((item, index) => (
                                    <div className="flex items-center gap-2" key={index}>
                                        <Checkbox
                                            className="sl-cursor-pointer"
                                            checked={selectedAffiliateIds.includes(item.affiliate_id)}
                                            id={item.affiliate_id}
                                            onChange={(e) => {
                                                if (e.target.checked) {
                                                    setAffiliateIds([...selectedAffiliateIds, item.affiliate_id]);
                                                } else {
                                                    setAffiliateIds(selectedAffiliateIds.filter((id) => id !== item.affiliate_id));
                                                }
                                            }}
                                        />
                                        <Label htmlFor={item.affiliate_id}>{item.name}</Label>
                                    </div>

                                ))}
                            </div>
                        </Dropdown>
                        <Button color="blue" onClick={onClickFilter}>Filter</Button>
                        <Button color="gray" onClick={onClickReset}>Reset</Button>
                    </div>

                    {affiliatesFetched ? (
                        <div className="sl-table-container">
                            <PaginatedTable
                                headers={tableHeaders}
                                data={affiliateData}
                            />
                        </div>
                    ) : (
                        <div className="sl-self-center sl-mt-3 sl-mb-21">
                            <LoadSpinner/>
                        </div>
                    )}
                    {affiliatePagination.total_pages > 1 && affiliatesFetched && (
                        <Pagination paginationData={affiliatePagination}
                                    basePath={`/admin/affiliate_clicks`}
                                    paginator={affiliatePagination}/>
                    )}
                </div>
            </main>
        </div>
    );
};

export default AffiliateClicks;
